import { filterExclusives } from '@/staff/primary/Exclusives.ui';
import { computed, defineComponent, PropType, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { ExclusiveUi } from '@/staff/primary/exclusive/Exclusive.ui';
import { FairplayerButtonVue } from '@/common/primary/button';
import { AuctionExclusiveRowVue } from './auction-exclusive-row';

export default defineComponent({
  name: 'AuctionExclusivesTable',

  props: {
    auctionId: {
      type: String as PropType<string>,
      required: true,
    },
    exclusives: {
      type: Object as PropType<ExclusiveUi[]>,
      required: true,
    },
  },

  components: { FairplayerButtonVue, AuctionExclusiveRowVue },

  setup(props) {
    const { t } = useI18n();

    const terms = ref('');
    const showNotVisibleExclusives = ref(true);

    const hasExclusives = computed(() => props.exclusives.length > 0);

    const filteredExclusives = computed(() => filterExclusives(props.exclusives, showNotVisibleExclusives.value, terms.value));

    return {
      filteredExclusives,
      hasExclusives,
      showNotVisibleExclusives,
      terms,
      t,
    };
  },
});
